import {connect} from 'react-redux';
import GeneralForm from './GeneralForm.jsx';
import {
  validate,
  handleSave,
  handleCancel
} from './actions';
import {handlePartnerLoginClick, handleExitPartnerClick} from '../../shared/topBanner/actions';

const mapStateToProps = state => ({
  validate: validate,
  submitLabel: 'Create',
  timeZones: state.tournament.general.timeZones,
  themes: state.tournament.general.themes,
  cards: state.tournament.general.cards,
  exportOptions: state.tournament.general.exportOptions,
  stripeAccountOptions: state.tournament.general.stripeAccounts,
  groupName: state.shared.auth.groupName,
  isAllowed: state.shared.auth.isAllowed,
  permissions: state.shared.auth.permissions,
  canEditTournamentName: true
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: data => dispatch(handleSave(data)),
  onCancel: () => dispatch(handleCancel()),
  onPartnerLoginClick: () => dispatch(handlePartnerLoginClick()),
  onExitPartnerClick: () => dispatch(handleExitPartnerClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralForm);



// WEBPACK FOOTER //
// ./src/features/tournament/general/AddGeneralContainer.jsx